// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-lesotho/calculator-lesotho-business-loan/calculator-lesotho-business-loan.component.scss
// module id = 646
// module chunks = 0